<h1 mat-dialog-title>Importar leads</h1>

<mat-dialog-content [formGroup]="form">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Origen</mat-label>
          <mat-select formControlName="origin_id">
            @for (origin of origins; track origin.id) {
              <mat-option [value]="origin.id">{{ origin.name }}</mat-option>
            }
          </mat-select>
          <mat-hint>Selecciona el origen de los leads a importar</mat-hint>
        </mat-form-field>
      </div>

      @if (selectedOrigin && !supportsImport) {
        <div class="col-12">
          <p class="hint-warning">La importación para «{{ selectedOrigin.name }}» aún no está disponible.</p>
        </div>
      }

      @if (supportsImport) {
        <div class="col-12">
          <p class="hint">Sube el export CSV de Apollo (contacts export).</p>
          <ngx-dropzone (change)="onSelect($event)" [accept]="'.csv,text/csv,application/vnd.ms-excel'" [multiple]="false">
            <ngx-dropzone-label>Arrastra el CSV o haz clic para seleccionarlo</ngx-dropzone-label>
            @for (f of files; track f) {
              <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)">
                <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
              </ngx-dropzone-preview>
            }
          </ngx-dropzone>
        </div>
      }

      @if (error_message) {
        <div class="col-12">
          <p class="hint-error">{{ error_message }}</p>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()" [disabled]="importing">Cancelar</button>
  <button
    mat-flat-button
    color="accent"
    type="button"
    (click)="submit()"
    [disabled]="!form.valid || !supportsImport || files.length === 0 || importing"
  >
    <mat-icon style="margin-right: 8px">upload_file</mat-icon>
    {{ importing ? 'Importando…' : 'Importar' }}
  </button>
</mat-dialog-actions>
